/**
 * Global error filter — ignore known benign errors so they are not logged to console.
 * Used by prebootstrap and createAppRoot global error handlers.
 * List aligned with Sentry beforeSend filter (src/lib/sentry.ts).
 */

const IGNORED_MESSAGES = [
  'ResizeObserver loop completed with undelivered notifications',
] as const;

/**
 * Returns true if the error event should not be logged (e.g. ResizeObserver browser quirk).
 */
export function shouldIgnoreGlobalError(event: ErrorEvent): boolean {
  const msg =
    (event.error && typeof (event.error as Error).message === 'string' && (event.error as Error).message) ||
    (typeof event.message === 'string' ? event.message : '');
  if (typeof msg !== 'string') return false;
  return IGNORED_MESSAGES.some((ignored) => msg.includes(ignored));
}
